/** * * Asynchronously loads the component for
FixedPhoneFlow
* */ import { lazyLoad } from "utils/loadable";
export const FixedPhoneFlow = lazyLoad(
  () => import("./index"),
  (module) => module.FixedPhoneFlow
);
